import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SharePassphrase_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', passphrase?: string | null };

export type SharePassphrase_CollectionShare_Fragment = { __typename?: 'CollectionShare', passphrase?: string | null };

export type SharePassphraseFragment = SharePassphrase_AdHocAssetsShare_Fragment | SharePassphrase_CollectionShare_Fragment;

export const SharePassphrase = /*#__PURE__*/ gql`
    fragment SharePassphrase on Share {
  passphrase
}
    ` as unknown as DocumentNode<SharePassphraseFragment, unknown>;

        

        
export const useSharePassphraseFragment = (
  input: string | Omit<UseFragmentOptions<SharePassphraseFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<SharePassphraseFragment>({
    fragment: SharePassphrase,
    fragmentName: 'SharePassphrase',
    ...options,
  });
};
  
        